import React from 'react';

// Inline crown so it renders everywhere: the ♛ glyph is missing from many
// font stacks and shows up as a "?" box.
function CrownIcon({ className = '' }) {
  return (
    <svg
      className={`crown-icon ${className}`.trim()}
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M4.2 16 2.6 8.2l5.1 3.6L12 5.4l4.3 6.4 5.1-3.6-1.6 7.8z" />
      <circle cx="2.6" cy="7.4" r="1.6" />
      <circle cx="12" cy="4.4" r="1.6" />
      <circle cx="21.4" cy="7.4" r="1.6" />
      <rect x="4.2" y="17.4" width="15.6" height="2.6" rx="1" />
    </svg>
  );
}

export default CrownIcon;
